import { cn as e } from "../../lib/utils.es.js";
import { Button as t } from "../ui/button.es.js";
import { Popover as n, PopoverContent as r, PopoverTrigger as i } from "../ui/popover.es.js";
import { Label as a } from "../ui/label.es.js";
import { Calendar as o } from "../ui/calendar.es.js";
import { TimePicker as s } from "../TimePicker/TimePicker.es.js";
import { useState as c } from "react";
import { CalendarIcon as l } from "lucide-react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { endOfDay as f, format as p, startOfDay as m, subDays as h } from "date-fns";
// libs/ui-lib/src/components/DateRangePicker/DateRangePicker.tsx
var g = [
	{
		label: "Today",
		getRange: () => ({
			from: m(/* @__PURE__ */ new Date()),
			to: /* @__PURE__ */ new Date()
		})
	},
	{
		label: "Yesterday",
		getRange: () => {
			let e = h(/* @__PURE__ */ new Date(), 1);
			return {
				from: m(e),
				to: f(e)
			};
		}
	},
	{
		label: "Last 7 days",
		getRange: () => ({
			from: m(h(/* @__PURE__ */ new Date(), 6)),
			to: /* @__PURE__ */ new Date()
		})
	},
	{
		label: "Last 14 days",
		getRange: () => ({
			from: m(h(/* @__PURE__ */ new Date(), 13)),
			to: /* @__PURE__ */ new Date()
		})
	},
	{
		label: "Last 30 days",
		getRange: () => ({
			from: m(h(/* @__PURE__ */ new Date(), 29)),
			to: /* @__PURE__ */ new Date()
		})
	}
];
function _(e, t, n) {
	let r = new Date(e);
	return t ? r.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()) : n ? r.setHours(23, 59, 59, 999) : r.setHours(0, 0, 0, 0), r;
}
function v({ label: e, value: t, onChange: n, dataTestId: r }) {
	return /* @__PURE__ */ d("div", {
		className: "flex flex-1 items-center gap-2",
		children: [/* @__PURE__ */ u(a, {
			className: "text-muted-foreground text-xs",
			children: e
		}), /* @__PURE__ */ u(s, {
			value: t,
			onChange: n,
			dataTestId: r
		})]
	});
}
function y({ value: a, onChange: s, presets: f = g, showTime: m = !1, placeholder: h = "Pick a date range", minDate: y, maxDate: b, numberOfMonths: x = 2, disabled: S = !1, align: C = "start", id: w, className: T, dataTestId: E = "date-range-picker" }) {
	let [D, O] = c(!1), [k, A] = c(void 0), [j, M] = c(void 0), N = k ?? a, P = j ?? a, F = (e) => m ? p(e, "MMM d, yyyy, h:mm a") : p(e, "MMM d, yyyy"), I = a ? `${F(a.from)} – ${F(a.to)}` : h, L = !k?.from || !k?.to, R = () => {
		k?.from && k?.to && (s?.({
			from: _(k.from, j?.from ?? a?.from, !1),
			to: _(k.to, j?.to ?? a?.to, !0)
		}), A(void 0), M(void 0), O(!1));
	}, z = () => {
		A(void 0), M(void 0), O(!1);
	};
	return /* @__PURE__ */ d(n, {
		open: D,
		onOpenChange: (e) => {
			O(e), A(void 0), M(void 0);
		},
		children: [/* @__PURE__ */ u(i, {
			asChild: !0,
			children: /* @__PURE__ */ d(t, {
				id: w,
				variant: "outline",
				disabled: S,
				"data-testid": E,
				className: e("h-9 min-w-0 justify-between gap-2 px-3 font-normal", !a && "text-muted-foreground", T),
				children: [/* @__PURE__ */ u("span", {
					className: "truncate",
					children: I
				}), /* @__PURE__ */ u(l, { className: "size-4 shrink-0 text-muted-foreground" })]
			})
		}), /* @__PURE__ */ d(r, {
			className: "flex max-h-[var(--radix-popover-content-available-height)] w-auto flex-col overflow-hidden p-0",
			align: C,
			children: [/* @__PURE__ */ d("div", {
				className: "flex min-h-0 overflow-y-auto",
				children: [f.length > 0 ? /* @__PURE__ */ u("div", {
					className: "flex flex-col gap-0.5 border-border border-r p-2",
					children: f.map((e) => /* @__PURE__ */ u(t, {
						variant: "ghost",
						size: "sm",
						className: "justify-start font-normal",
						"data-testid": `${E}--preset-${e.label.toLowerCase().replace(/\s+/g, "-")}`,
						onClick: () => {
							let t = e.getRange();
							A(t), M(t);
						},
						children: e.label
					}, e.label))
				}) : null, /* @__PURE__ */ d("div", { children: [/* @__PURE__ */ u(o, {
					mode: "range",
					selected: N,
					defaultMonth: N?.from,
					numberOfMonths: x,
					captionLayout: "dropdown",
					startMonth: y,
					endMonth: b,
					classNames: { months: "relative flex flex-row gap-4" },
					disabled: [...y ? [{ before: y }] : [], ...b ? [{ after: b }] : []],
					onSelect: (e) => {
						A(e), e?.from && e?.to && M({
							from: _(e.from, j?.from ?? a?.from, !1),
							to: _(e.to, j?.to ?? a?.to, !0)
						});
					}
				}), m && P ? /* @__PURE__ */ d("div", {
					className: "flex items-center gap-4 border-border border-t p-3",
					children: [/* @__PURE__ */ u(v, {
						label: "From",
						value: P.from,
						dataTestId: `${E}--time-from`,
						onChange: (e) => M({
							from: e,
							to: P.to
						})
					}), /* @__PURE__ */ u(v, {
						label: "To",
						value: P.to,
						dataTestId: `${E}--time-to`,
						onChange: (e) => M({
							from: P.from,
							to: e
						})
					})]
				}) : null] })]
			}), /* @__PURE__ */ d("div", {
				className: "flex shrink-0 justify-end gap-2 border-border border-t p-2",
				children: [/* @__PURE__ */ u(t, {
					variant: "default",
					size: "sm",
					"data-testid": `${E}--apply`,
					disabled: L,
					onClick: R,
					children: "Apply"
				}), /* @__PURE__ */ u(t, {
					variant: "outline",
					size: "sm",
					"data-testid": `${E}--cancel`,
					onClick: z,
					children: "Cancel"
				})]
			})]
		})]
	});
}
export { g as DEFAULT_DATE_RANGE_PRESETS, y as DateRangePicker };
